module.exports = __webpack_public_path__ + "static/media/zapsplat_cartoon_pull_squeak_pop_45774.7ec9bf4a.mp3";